import { LegalShell, Section, DataOwnershipBlock, ProviderDisclaimer } from "@/components/legal/LegalShell";

export default function TermsOfService() {
  return (
    <LegalShell title="Terms of Service">
      <p>
        These Terms of Service ("Terms") govern your use of <strong>RecoverOS</strong>, a software-as-a-service platform
        operated by <strong>Trustera Services</strong>, New Delhi, India. By creating an account or using the service, you
        agree to these Terms.
      </p>

      <ProviderDisclaimer />

      <Section title="1. Subscription Terms">
        <p>RecoverOS may be offered through subscription plans, introductory PAYG access, trials, or other promotional access programs, as made available from time to time. Plan limits (accounts, users and features) apply as described at sign-up. Fees are billed in advance for the chosen billing cycle. We may update plans and pricing with reasonable notice.</p>
      </Section>

      <Section title="2. User Responsibilities">
        <ul className="space-y-1.5 list-disc list-inside">
          <li>You are responsible for the accuracy and lawfulness of data you upload.</li>
          <li>You must keep credentials secure and are responsible for activity under your account.</li>
          <li>You must use the service in compliance with all laws and regulations applicable to your business.</li>
          <li>You must not attempt to access other tenants' data or circumvent security controls.</li>
        </ul>
      </Section>

      <Section title="3. Data Ownership">
        <DataOwnershipBlock />
      </Section>

      <Section title="4. Communication Provider Responsibility">
        <p>RecoverOS provides workflow and communication-integration tools. Where you connect WhatsApp, SMS, email or telephony providers, you remain solely responsible for communication consent, regulatory compliance, message content and communication frequency.</p>
        <div className="border-l-4 border-[#0B3D91] bg-[#0B3D91]/5 p-5">
          <p className="font-semibold text-slate-900">Consent clause</p>
          <p className="mt-2">The tenant is responsible for obtaining all necessary customer communication consents.</p>
        </div>
      </Section>

      <Section title="5. Service Availability">
        <p>We strive to provide a reliable, highly available service but do not guarantee uninterrupted access. Maintenance, updates or factors outside our control may cause temporary unavailability. The service is provided on an "as available" basis.</p>
      </Section>

      <Section title="6. Limitation of Liability">
        <p>To the maximum extent permitted by law, RecoverOS and Trustera Services shall not be liable for indirect, incidental, special or consequential damages, or for any loss arising from the tenant's recovery, collection or communication activities. Our aggregate liability shall not exceed the fees paid by the tenant in the three months preceding the claim.</p>
      </Section>

      <Section title="7. Cancellation Policy">
        <p>You may cancel at any time. Access continues until the end of the current billing cycle. Fees already paid are non-refundable. Following cancellation, you may export your data for <strong>90 days</strong>, after which it is permanently deleted or anonymized.</p>
      </Section>

      <Section title="8. Governing Law">
        <p>These Terms are governed by the laws of India, and the courts of New Delhi shall have exclusive jurisdiction over any disputes.</p>
      </Section>

      <Section title="9. Contact">
        <p>Questions about these Terms: <a href="mailto:support@recoveros.in" className="text-[#0B3D91] font-semibold">support@recoveros.in</a> · +91 78400 52502 · Trustera Services, New Delhi, India.</p>
      </Section>
    </LegalShell>
  );
}
